export type Attribute = 'name' | 'value';
export const ATTRIBUTES: readonly Attribute[] = ['name', 'value'] as const;

export type ElementWithValue =
  | HTMLInputElement
  | HTMLSelectElement
  | HTMLTextAreaElement;
